const config =
    process.env.NODE_ENV === "production" ?
        {
            baseUrl: 'https://admin.readeo.co.kr/api/',
        }
        :  {
            baseUrl: 'http://localhost:8000/',
        };
export default config;